import { DropdownButton, Dropdown } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight, faChevronLeft } from '@fortawesome/pro-light-svg-icons';
import PropTypes from 'prop-types';
import './style.scss';

const PageNavigation = ({ handleSelectPage, pageCount, currentPage, minimised = false }) => {
  const visiblePageCount = minimised ? 5 : 10;

  const getVisiblePages = () => {
    const maxVisiblePages = Math.min(pageCount, visiblePageCount);

    if (pageCount <= maxVisiblePages) {
      return Array.from({ length: maxVisiblePages }, (_, index) => index + 1);
    }

    const leadingPages = Math.floor(maxVisiblePages / 2);
    const trailingPages = maxVisiblePages - leadingPages - 1;
    let startPage = currentPage - leadingPages;
    let endPage = currentPage + trailingPages;

    if (startPage < 1) {
      endPage += 1 - startPage;
      startPage = 1;
    }

    if (endPage > pageCount) {
      startPage -= endPage - pageCount;
      endPage = pageCount;
    }

    return Array.from({ length: maxVisiblePages }, (_, index) => startPage + index);
  };

  const visiblePages = getVisiblePages();

  return (
    <div id='pageNavigator' className='pageNavigator'>
      <div className={`chevPageBtn ${currentPage <= 1 ? 'disabled' : ''}`} onClick={() => currentPage <= 1 ? undefined : handleSelectPage(currentPage - 1)}>
        <FontAwesomeIcon color={currentPage <= 1 ? '#8080803d' : '#7085C5'} icon={faChevronLeft} />
      </div>
      {visiblePages.map((pageNumber, i) => {
        return (
          <div className={`pageBtn ${pageNumber == currentPage ? 'selected' : ''} `} key={`pageBtn_${i}`} onClick={() => handleSelectPage(pageNumber)}>{pageNumber}</div>
        );
      })}
      <div className={`chevPageBtn ${currentPage >= pageCount ? 'disabled' : ''}`} onClick={() => currentPage >= pageCount ? undefined : handleSelectPage(currentPage + 1)}>
        <FontAwesomeIcon color={currentPage >= pageCount ? '#8080803d' : '#7085C5'} icon={faChevronRight} />
      </div>
      <DropdownButton id='dropdown-page-selection' title={currentPage} variant='castleDropdown' className='mx-2' drop='up'>
        {Array.from({ length: Math.min(pageCount) }, (_, i) => (
          <Dropdown.Item key={`dropDown-Item${i}`} active={currentPage == i + 1} onClick={() => handleSelectPage(i + 1)}>{i + 1}</Dropdown.Item>
        ))}
      </DropdownButton>
    </div>
  );
};

PageNavigation.propTypes = {
  handleSelectPage: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
  currentPage: PropTypes.number.isRequired,
  minimised: PropTypes.bool
};

export default PageNavigation;